import { c as _c } from "react/compiler-runtime";
import { postEntitiesSearchCount } from '@onefootprint/fetch-dashboard';
import type { VaultKind } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import useEntitiesQueryParams from '@/components/entities/hooks/use-entities-query-params';
import useSession from '@/hooks/use-session';
const USE_MANUAL_REVIEW_FETCH_INTERVAL = 5 * 60 * 1000; // 5 minutes

const useManualReview = entityKind => {
  const $ = _c(11);
  const {
    authHeaders,
    isLive
  } = useSession();
  const queryParams = useEntitiesQueryParams();
  const {
    requestParams
  } = queryParams;
  let t0;
  if ($[0] !== authHeaders || $[1] !== entityKind || $[2] !== isLive || $[3] !== requestParams) {
    t0 = ["entities", entityKind, "manual-review", requestParams, authHeaders, isLive];
    $[0] = authHeaders;
    $[1] = entityKind;
    $[2] = isLive;
    $[3] = requestParams;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== entityKind || $[6] !== requestParams) {
    t1 = () => postEntitiesSearchCount({
      body: {
        maxCount: 100,
        kind: entityKind,
        requiresManualReview: true,
        statuses: requestParams.statuses
      }
    });
    $[5] = entityKind;
    $[6] = requestParams;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t0 || $[9] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      refetchInterval: USE_MANUAL_REVIEW_FETCH_INTERVAL
    };
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return useQuery(t2);
};
export default useManualReview;